module.exports = __webpack_public_path__ + "static/other/en-US.f2e08d45.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/lingual/en-US.json
// module id = 1858
// module chunks = 0